import { Provider } from '@angular/core';
import { SearchService } from './search.service';
import { SearchStore } from './state';

export const SEARCH_PROVIDERS: Provider[] = [SearchStore, SearchService];
